export default "__VITE_ASSET__616aefa2__"